import React, { useEffect, useState } from 'react';
import styles from './ActivatePointOfContact.styles.scss';

import { Header } from '../../components/Header';
import cn from 'classnames';
import { useSearchParams } from 'react-router-dom';
import * as api from '../../services/apis';
import { Loader } from '../../components/shared/Loading';
import { useTranslation } from 'react-i18next';

const ActivatePointOfContact = () => {
  let [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const [status, setStatus] = useState();
  const [loading, setLoading] = useState(true);

  const token = searchParams.get('token');
  useEffect(() => {
    setTimeout(() => {
      api
        .activatePointOfContact(token)
        .then((data) => {
          setStatus(data.data.status);
        })
        .catch(() => {
          setStatus('FAILED');
        })
        .finally(() => {
          setLoading(false);
        });
    }, 3000);
  }, []);
  return (
    <div className={cn(styles.layout)}>
      <Header />
      <div className={cn(styles.inner)}>
        <Loader active={loading}>
          {status === 'ACTIVE' && (
            <h1>
              {t(
                'manage-notifications.point-of-contact-activated-successfully',
              )}
            </h1>
          )}
          {status === 'ALREADY_ACTIVE' && (
            <h1>{t('manage-notifications.point-of-contact-already-active')}</h1>
          )}
          {status === 'FAILED' && (
            <h1>
              {t(
                'manage-notifications.failed-to-activate-point-of-contact-please-try-again',
              )}
            </h1>
          )}
        </Loader>
      </div>
    </div>
  );
};

export default React.memo(ActivatePointOfContact);
